(function () {

    angular.module("EventListApp").directive('lazyScroll', ['$window', function ($window) {
        var loadData, scrollTrigger = 300, scrollEnabled = true;
        return {
            //scope: {
            //    links: '=',
            //},
            link: function (scope, elem, attrs) {
                scrollEnabled, loadData, scrollTrigger;
                $window = angular.element($window);

                if ((attrs.lazyScrollTrigger != undefined) && (attrs.lazyScrollTrigger > 0)) {
                    scrollTrigger = attrs.lazyScrollTrigger;
                }

                loadData = function () {
                    if (attrs.allowScroll != null) {
                        if (attrs.allowScroll == "true")
                            return scope.$apply(attrs.lazyScroll);
                    }
                    else
                        return scope.$apply(attrs.lazyScroll);
                };

                $window.on('scroll', loadData);
                scope.$on('$destroy', function () {
                    return $window.off('scroll', loadData);
                });
            }
        };
    }
    ]);
})();


